import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class CompetencyTypesService {

  constructor(private http: HttpClient) { }

  public getAllCompetencyTypesNoPagination() {
    return this.http.get<any[]>(environment.apiUrl + 'api/ext-competency-type?size=10000000&page=0')
      .pipe(catchError(this.handleError));
  }

  public getAllCompetencyTypes(pagination) {

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    return this.http.get(environment.apiUrl + 'api/ext-competency-type' + paginationString, { observe: 'response' })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  public getAllCompetencyTypesByType(type) {
    return this.http.get(environment.apiUrl + 'api/ext-competency-type/by-type/' + type + '?size=10000000&page=0')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public getAllCompetencyTypesByTypeFilteredForSiteOwner(type, siteOwnerSkylarkId) {
    return this.http.get(environment.apiUrl + 'api/ext-competency-type/by-type/' + type + '?size=10000000&page=0')
      .pipe(map(result => {
        const normalizedResult = ((result as any[]) || []).map((item) => ({
          ...item,
          competencyCategory: item.type,
        }));

        if (siteOwnerSkylarkId === environment.WFSO_OWNER_SKYLARK_ID) {
          return normalizedResult.filter(c => environment.WFSO_FILTERED_COMPETENCIES.includes(c.id));
        }
        return normalizedResult;
      }))
      .pipe(catchError(this.handleError));
  }

  public getAllCompetencyTypesByAssetType(id) {
    return this.http.get(environment.apiUrl + 'api/ext-competency-type/by-asset-category/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public createCompetencyType(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-competency-type', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public editCompetencyType(obj) {
    return this.http.put(environment.apiUrl + 'api/ext-competency-type', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError))
  }

  public deleteCompetency(id) {
    return this.http.delete(environment.apiUrl + 'api/ext-competency-type/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Handle Responses
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }


  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }

}
